<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{ 'tension.tension-parent-label' | translate }}"
      pageTitle="{{ 'tension.tension-page-label' | translate }}">
    </app-page-header>
  </div>

  <!--Corpo do componente-->
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-register-form></app-register-form>
        <div class="form-fields-box" [ngClass]="!register ? 'closed' : ''" [formGroup]="registerTensionForm">
          <h2 (click)="registerBox()">
            {{ "tension.form-register-label" | translate }}
          </h2>
          <hr [ngClass]="!register ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{ "tension.form-high_tension" | translate }}</mat-label>
              <input matInput formControlName="high_tension" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>{{ "tension.form-low_tension" | translate }}</mat-label>
              <input matInput formControlName="low_tension" />
            </mat-form-field>
          </div>

          @if (!registerLoading) {
          <button title="{{ 'tension.form-save-button' | translate }}" class="btn btn-success"
            [disabled]="registerTensionForm.invalid" (click)="registerTension()">
            {{ "tension.form-save-button" | translate }}
          </button>
          }
          @if (registerLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>

        <div class="form-fields-box" [ngClass]="!filter ? 'closed' : ''">
          <h2 (click)="filterBox()">
            {{ "tension.form-filter-label" | translate }}
          </h2>
          <hr [ngClass]="!filter ? 'hr-open' : ''" />

          @if (!filterLoading) {
          <button title="{{ 'tension.form-filter-button' | translate }}" class="btn btn-success"
            (click)="filterTension()">
            {{ "tension.form-filter-button" | translate }}
          </button>
          }
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    @if (totalNumber) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="totalNumber" [totalNumber]="totalNumber" [hasCSV]="true" [hasPDF]="true"
        (downloadCSV)="generateFileData('CSV')" [loadingData$]="fileLoading" (downloadPDF)="generateFileData('PDF')">
      </app-table-header>
      <div class="table-container mt-2 mt-lg-3">
        <p-table [value]="ELEMENT_DATA" dataKey="id" [rows]="5" [paginator]="true" [showPageLinks]="false"
          [showFirstLastIcon]="false">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="highTension">{{ "tension.form-high_tension" | translate }}</th>
              <th pSortableColumn="lowTension">{{ "tension.form-low_tension" | translate }}</th>
              <th pSortableColumn="actions">{{ "tension.form-actions" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>
                {{row.highTension}}
              </td>
              <td>
                {{row.lowTension}}
              </td>
              <td>
                <!-- Botão de edição -->
                <p-button styleClass="btn-actions" [rounded]="true" icon="pi pi-pen-to-square"
                  (click)="updateGetter(row.highTension, row.lowTension)" />

                <!-- Botão de deleção -->
                <p-button styleClass="btn-view" [rounded]="true" icon="pi pi-trash" (click)="deleteConfirm()" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>

  <!-- Componente de edição -->
  @if (editorController) {
  <div class="sidebar-edit" [formGroup]="updateForm">
    <mat-icon (click)="closeEditionSideBar()">clear</mat-icon>
    <h2>{{ "tension.form-edit-label" | translate }}</h2>
    <hr>
    <mat-form-field appearance="outline">
      <mat-label>{{ "tension.form-high_tension" | translate }}</mat-label>
      <input matInput formControlName="high_tension" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ "tension.form-low_tension" | translate }}</mat-label>
      <input matInput formControlName="low_tension" />
    </mat-form-field>
    <button class="btn btn-success" (click)="updateTension()">{{"tension.form-save-button" | translate}}</button>
  </div>
  }
</div>